"use client";
import React, { FC, ReactNode, useEffect } from "react";
import styles from "./styles.module.scss";
import navs from "@/data/navs";
import Link from "next/link";
import uniqid from "uniqid";
import logo from "../../../assets/images/logo.svg";
import Image from "next/image";
import houzz from "../../../assets/images/houzz.svg";
import pinterest from "../../../assets/images/pinterest.svg";
import alliance from "../../../assets/images/alliance-paysage.svg";
import allianceMobile from "../../../assets/images/alliance_mobile.svg";
import classNames from "classnames";
import { usePathname } from "next/navigation";
import startIcon from "../../../assets/images/start_outiline.svg";

export const Footer = ({
  global_rate,
  total_reviews,
}: {
  global_rate: number;
  total_reviews: number;
}) => {
  const pathname = usePathname();

  return (
    <footer className={styles.footer}>
      <div className={styles.contents}>
        <div className={styles.left}>
          <div>
            <h2>NOS BUREAUX</h2>
            <a
              href="https://www.google.com/maps/place/Cockenpot+PAYSAGE/@50.5454978,2.8217412,17z/data=!3m1!4b1!4m6!3m5!1s0x47dd2f6a166a5681:0xc1923a276b671b2a!8m2!3d50.5454978!4d2.8217412!16s%2Fg%2F1td096kb?entry=ttu"
              target="__blank"
              className="hover:underline"
            >
              <p>
                Route Nationale 41
                <br />
                59480 Illies / La Bassée
              </p>
            </a>
          </div>
          <div>
            <h2>CONTACT</h2>
            <p>
              <a href="tel:03.20.29.06.24" className="hover:underline">
                03.20.29.06.24
              </a>
              <br />
            </p>
          </div>
          <div className="block lg:hidden">
            <h2>Ce qu’on dit de nous</h2>
            <p>
              <span className="flex lg:justify-end mt-[4px] gap-x-[4px] items-center">
                <Image src={startIcon} alt="start" />
                <span className="font-poppins font-light">
                  {global_rate} / 10 ({total_reviews} avis)
                </span>
              </span>
            </p>
          </div>
        </div>
        <div className={styles.right}>
          <nav className={styles.navs}>
            {navs.map(({ label, url }) => (
              <Link
                className={classNames(styles.link, {
                  [styles.active]: pathname === url,
                })}
                href={url}
                key={uniqid()}
              >
                <span className={styles.label}>{label}</span>
              </Link>
            ))}
          </nav>
          <div className={styles.rate_container_desktop}>
            <p className="text-right">
              <span className="font-poppins font-semibold lg:text-[16px] 2xl:text-[20px] leading-none">
                Ce qu’on dit de nous
              </span>
              <br />
              <span className="flex justify-end mt-[4px] gap-x-[4px] items-center">
                <Image src={startIcon} alt="start" />
                <span className="font-poppins font-light lg:text-[16px] 2xl:text-[20px] leading-none">
                  {global_rate} / 10 ({total_reviews} avis)
                </span>
              </span>
            </p>
          </div>
        </div>
        <div className={styles.bottom}>
          <Image src={logo} alt="Cockenpot Paysage" className={styles.logo} />
          <div className={styles.social_network}>
            <a
              href="https://www.pinterest.fr/cockenpotpaysag/"
              title="Cockenpot Paysage Pinterest"
              target="_blank"
              className={styles.social_network_pinterest}
              style={{
                WebkitMaskImage: `url(${pinterest.src})`,
                maskImage: `url(${pinterest.src})`,
              }}
            ></a>
            <a
              href="https://www.houzz.fr/professionnels/paysagiste-et-architecte-paysagiste/cockenpot-paysage-createur-de-jardins-pfvwfr-pf~849490050?"
              title="Cockenpot Paysage Houzz"
              target="_blank"
              className={styles.social_network_houzz}
              style={{
                WebkitMaskImage: `url(${houzz.src})`,
                maskImage: `url(${houzz.src})`,
              }}
            ></a>
          </div>
        </div>
        <div className={styles.partenaire_container}>
          <Image
            src={alliance}
            alt="Alliance Paysage"
            className={styles.desktop}
          />
          <Image
            src={allianceMobile}
            alt="Alliance Paysage"
            className={styles.mobile}
          />
        </div>
      </div>
      <div className={styles.mention_legal}>
        <p>
          © COCKENPOT Paysage Tous droits réservés 2023.{" "}
          <Link href="/#">Mentions légales</Link>. Réalisé par MISTER_E
        </p>
      </div>
    </footer>
  );
};
